import { render, staticRenderFns } from "./SmallTooltip.vue?vue&type=template&id=12fea94a"
import script from "./SmallTooltip.vue?vue&type=script&lang=js"
export * from "./SmallTooltip.vue?vue&type=script&lang=js"
import style0 from "./SmallTooltip.vue?vue&type=style&index=0&id=12fea94a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports